
import { Vue, Component } from 'vue-property-decorator';

// Components
import { VAppLayout, VAppMain, VAppHeader, VAppFooter } from '@/components/VApp';
import HomeServicesTiles from '@/components/ServiceElement/HomeServicesTiles.vue';

@Component({
    components: {
        VAppLayout,
        VAppMain,
        VAppHeader,
        VAppFooter,
        HomeServicesTiles,
    },
})
export default class HomeServicesPage extends Vue {}
